module.exports = __webpack_public_path__ + "static/media/vitez_dashboard.37497cbe.png";